export default __webpack_public_path__ + "static/media/1097.4b31570e.png";